<template>
<kt-panel>
    <div class="accordion accordion-toggle-arrow" id="userFilter">
        <div class="card" style="overflow:inherit">
            <div class="card-header bg-transparent" id="headingOne">
                <div class="card-title collapsed" data-toggle="collapse" 
                    data-target="#filterForm"
                    aria-controls="filterForm">
                    {{ $t('label.search') }}
                </div>
            </div>
            <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#userFilter">
                <div class="card-body">
                    <form @submit.prevent="action($event, query)">
                        <kt-form-section>
                            <kt-form-row>
                                <kt-col xs="12" sm="12" md="4" lg="4">
                                    <kt-form-group>
                                        <kt-form-label for="settlement_id">
                                            {{ $t('label.settlement_id') }}
                                        </kt-form-label>
                                        <kt-form-control
                                                ref="settlement_id"
                                                dir="ltr"
                                                name="settlement_id"
                                                id="settlement_id"
                                                v-model="query.settlement_id"
                                        />
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="12" md="4" lg="4">
                                    <kt-form-group>
                                        <kt-form-label for="amount">
                                            {{ $t('label.amount') }}
                                        </kt-form-label>
                                        <kt-form-control ref="amount" dir="ltr" name="amount" id="amount" v-model="query.amount" />
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="12" md="4" lg="4">
                                    <kt-form-group>
                                        <kt-form-label for="filter_status">
                                            {{ $t('label.status') }}
                                        </kt-form-label>
                                        <kt-form-select size="4" id="status" class="form-control" name="status" v-model="query.status">
                                            <option
                                                    v-bind:key="index"
                                                    v-for="(status, index) in statuses"
                                                    v-bind:value="status.value"
                                                    :selected="query.status === status.value"
                                            >
                                                {{ status.name }}
                                            </option>
                                        </kt-form-select>
                                    </kt-form-group>
                                </kt-col>
                            </kt-form-row>
                        </kt-form-section>
                        <kt-form-section>
                            <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                        </kt-form-section>
                    </form>
                </div>
            </div>
        </div>
    </div>
</kt-panel>
</template>

<script>
import { statusStrForCommonAccess, settlementStatus } from '@/constants/settlementStatus'

export default {
    props: {
        action: {
            default: function(e, query) {},
            required: true,
        }
    },
    data() {
        return {
            statuses: [
                {
                    name: null,
                    value: null
                },
                {
                    name: statusStrForCommonAccess.PENDING,
                    value: settlementStatus.PENDING
                },
                {
                    name: statusStrForCommonAccess.ACCEPTED,
                    value: settlementStatus.ACCEPTED
                },
                {
                    name: statusStrForCommonAccess.REJECTED,
                    value: settlementStatus.REJECTED
                },
            ],
            query: {},
        }
    },
    mounted() {
    }
    
}
</script>

<style>

</style>